import { useState, useEffect } from "react";
import { API_URL, API_KEY } from "../config";
import { Preloader } from "./Preloader";
import { GoodsList } from "./GoodsList";
import { Cart } from "./Cart";
import { BasketList } from "./BasketList";
import { Alert } from "./Alert";

function Shop() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState([]);
  const [isBasketVisible, setIsBasketVisible] = useState(true);
  const [isOrderListVisible, setIsOrderListVisible] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [alertName, setAlertName] = useState('');

  useEffect(() => {
		setTotalPrice(
			order.reduce((sum, item) => {
				return sum + item?.price?.finalPrice * item?.quantity;
			}, 0)
		);
  }, [order]);
  
  const closeAlert = () => {
    setAlertName('');
  }

  const fetchList = async () => {
		try {
			const response = await fetch(API_URL, {
				method: 'GET',
				headers: {
					Authorization: API_KEY,
					'Content-Type': 'application/json',
				},
			});

      if (!response.ok) {
        setLoading(false);
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const data = await response.json();

      data.shop && setItems(data.shop);
      setLoading(false);
		} catch (err) {
      console.error('Error fetching items:', err);
      setLoading(false);
		}
  };

  const toggleBasketVisibility = () => {
    isBasketVisible ? setIsBasketVisible(false) : setIsBasketVisible(true);
    console.log(isBasketVisible);
  }

  const toggleOrderlListVisibility = () => {
    isOrderListVisible
		? setIsOrderListVisible(false)
		: setIsOrderListVisible(true);
  }
  
  const addToBasket = item => {
    console.log('basket', item);

    const itemIndex = order.findIndex(
      o => o.mainId === item.mainId && o.offerId === item.offerId
    );
    console.log('itemIndex', order[itemIndex]);
    const newItem = {
			...item,
			quantity: 1,
		};

    if (itemIndex !== -1) {
      const newOrder = [...order];
      newOrder[itemIndex].quantity += 1;
      setOrder(newOrder);
    } else {
      setOrder([...order, newItem]);
    }
    setAlertName(item.displayName);
  };

  const deleteFromBasket = (mainId, offerId) => {

		const itemIndex = order.findIndex(
			o => o.mainId === mainId && o.offerId === offerId
		);

		if (itemIndex !== -1) {
      const newOrder = order.filter(item => {
			  return item.mainId !== mainId && item.offerId !== offerId;
      });
			setOrder(newOrder);
		} else {
			setOrder([...order]);
		}
  };

  useEffect(() => {
    fetchList();
  }, [])

  const incrementItem = (mainId, offerId) => {
    const itemIndex = order.findIndex(
      o => o.mainId === mainId && o.offerId === offerId
    );

    const newOrder = [...order];
    newOrder[itemIndex].quantity += 1;
    setOrder(newOrder);
  };
  
  const decrementItem = (mainId, offerId) => {
    const itemIndex = order.findIndex(
      o => o.mainId === mainId && o.offerId === offerId
    );
    let newOrder = [...order];
    if (newOrder[itemIndex].quantity > 1) {
		  newOrder[itemIndex].quantity -= 1;
	  } else {
      newOrder = newOrder.filter(item => {
        return item.mainId !== mainId && item.offerId !== offerId;
      });
	  }
    setOrder(newOrder);
  };

  return (
		<main className='container content'>
			<Cart
        quantity={order.length ? (
          order.reduce((sum, item) => {
            return sum + (item?.quantity || 0);
          }, 0)
        ) : 0}
				basketVisibility={toggleBasketVisibility}
				isBasketVisible={isBasketVisible}
				orderListVisibility={toggleOrderlListVisibility}
			/>
			{loading ? (
				<Preloader />
			) : !items.length ? (
				<p>No items available</p>
			) : (
				<GoodsList
					goods={items}
					addToBasket={addToBasket}
				/>
			)}
			{isOrderListVisible && (
				<BasketList
					order={order}
					deleteFromBasket={deleteFromBasket}
					totalPrice={totalPrice}
          orderListVisibility={toggleOrderlListVisibility}
          incrementItem={incrementItem}
          decrementItem={decrementItem}
				/>
      )}
      {alertName && (
        <Alert name={alertName} closeAlert={closeAlert} />
      )}
		</main>
  );
}

export { Shop };